export default __webpack_public_path__ + "static/media/1b7f2098fdc315a0b5f2f13148aaa594.9dbb6777.png";